import {Group} from "@mantine/core";
import IconButton from "../../../button/icon/IconButton";
import {IconX} from "@tabler/icons-react";
import {useContext} from "react";
import BaseModalContext from "../BaseModalContext";

export type HeaderProps = {
    /**
     * Don't render the header.
     * @author Kacper Faber
     * @since 0.1.9
    */
    noHeader?: boolean;
};

function Header(props: HeaderProps) {
    /**
     * BaseModalContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const {close} = useContext(BaseModalContext);

    if (props.noHeader) {
        return (
            <></>
        );
    }

    return (
        <Group justify="right">
            <IconButton
                onClick={close}
                children={<IconX/>}
                s="sm"
            />
        </Group>
    );
}

export default Header;